export default "__VITE_ASSET__BswMRCTt__"